import z from "zod";

export const expressInterestFormSchema = z.object({
  message: z.string().optional(),
});

export type ExpressInterestFormValues = z.infer<
  typeof expressInterestFormSchema
>;
